import { createSlice } from '@reduxjs/toolkit';

export interface AnimatorSliceStates {
    projectImageAnimation?: string;
    logoShifted?: boolean;
}

export const AnimatorSlice = createSlice({
    name: 'animator',
    initialState: {
        projectImageAnimation: undefined,
        logoShifted: false,
    },
    reducers: {
        runProjectImageAnimation: (state, action) => {
            state.projectImageAnimation = action.payload;
        },
        clearProjectAnimation: (state, action) => {
            state.projectImageAnimation = undefined;
        },
        setLogoShift:  (state, action) => {
            state.logoShifted = action.payload;
        },
    },
});

export default AnimatorSlice
export const AnimatorActions = AnimatorSlice.actions
export const AnimatorSelector = (store: { animator: AnimatorSliceStates }): AnimatorSliceStates => store.animator;
import { createSlice } from '@reduxjs/toolkit';

export interface AnimatorSliceStates {
    projectImageAnimation?: string;
    logoShifted?: boolean;
}

export const AnimatorSlice = createSlice({
    name: 'animator',
    initialState: {
        projectImageAnimation: undefined,
        logoShifted: false,
    },
    reducers: {
        runProjectImageAnimation: (state, action) => {
            state.projectImageAnimation = action.payload;
        },
        clearProjectAnimation: (state, action) => {
            state.projectImageAnimation = undefined;
        },
        setLogoShift:  (state, action) => {
            state.logoShifted = action.payload;
        },
    },
});

export default AnimatorSlice
export const AnimatorActions = AnimatorSlice.actions
export const AnimatorSelector = (store: { animator: AnimatorSliceStates }): AnimatorSliceStates => store.animator;
